import React from 'react'
import { Outlet } from 'react-router-dom'

const MainPage = () => {

    return (
        <>
            <Outlet />
        </>
    )
}

export default MainPage